import { useState, useEffect } from 'react';

export type DomainType = 'main' | 'news' | 'innovate';

export const useDomain = (): DomainType => {
  const [domain, setDomain] = useState<DomainType>('main');

  useEffect(() => {
    const hostname = window.location.hostname;
    
    if (hostname.includes('news.nexx.net')) {
      setDomain('news');
    } else if (hostname.includes('nexxinnovate.com')) {
      setDomain('innovate');
    } else {
      setDomain('main');
    }
  }, []);

  return domain;
};

export const isDomain = (type: DomainType): boolean => {
  if (typeof window === 'undefined') return false;
  
  const hostname = window.location.hostname;
  
  switch (type) {
    case 'news':
      return hostname.includes('news.nexx.net');
    case 'innovate':
      return hostname.includes('nexxinnovate.com');
    case 'main':
    default:
      return !hostname.includes('news.nexx.net') && !hostname.includes('nexxinnovate.com');
  }
};